import useSWR from 'swr';
import api, { buildSaveRequestConfig } from '../../config/configApi';

const getToken = () => localStorage.getItem('token');

const fetcher = async (url) => {
  try {
    const { data } = await api.get(url);

    if (data?.erro) {
      throw new Error(data?.mensagem || 'Erro na API');
    }

    return data?.pendencias ?? [];
  } catch (err) {
    console.error('Erro ao buscar pendências:', err?.response?.status, err?.message);
    return [];
  }
};

export default function usePendenciasConfiguracoes() {
  const {
    data: pendencias = [], error, isLoading, mutate,
  } = useSWR(
    '/pendencias/config/pendencias',
    fetcher,
  );

  const criarPendencia = async (payload) => {
    try {
      const token = getToken();
      await api.post('/pendencias/config/pendencias', payload, buildSaveRequestConfig({
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      }));
      await mutate();
    } catch (err) {
      const status = err?.response?.status;
      if (status === 403) {
        throw new Error('Sem permissão para criar pendência.');
      }
      throw err;
    }
  };

  const editarPendencia = async (id, payload) => {
    try {
      await api.put(`/pendencias/config/pendencias/${id}`, payload);
      await mutate();
    } catch (err) {
      const status = err?.response?.status;
      if (status === 403) {
        throw new Error('Sem permissão para editar pendência.');
      }
      throw err;
    }
  };

  return {
    pendencias,
    isLoading,
    isError: !!error,
    criarPendencia,
    editarPendencia,
    refetch: mutate,
  };
}
